module.exports = __webpack_public_path__ + "static/img/产品1.6abc89c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/产品1.jpg
// module id = Z59i
// module chunks = 1